import cx from "classnames";
import Link from "next/link";

import { Text } from "@/components/elements/Text";

import styles from "./styles.module.css";

const CardUiTitle = ({ children, className = "", href = "" }) => {
  return (
    <Link href={href} className={styles.textLink}>
      <div className={cx(className, styles.titleContainer)}>
        <Text as="h3" size={"m"} disableMarginBottom={true}>
          {children}
        </Text>
      </div>
    </Link>
  );
};

export default CardUiTitle;
